module.exports = __webpack_public_path__ + "static/img/aa46b32e.png";